module.exports = __webpack_public_path__ + "static/media/bg_day.4fd39226.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/bg_day.png
// module id = 181
// module chunks = 0